import React, { Component, Fragment } from 'react';

import MobileAppProjects from '../components/projects/mobileAppProjects';
import ResponsiveAppBar from '../components/components/appbar';
import ResponsiveFooter from '../components/components/footer';

class MobileAppProject extends Component {

    render() {
        return (
            <Fragment>
                <ResponsiveAppBar />
                <div className="pageHeight">
                    <MobileAppProjects />
                </div>
                <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default MobileAppProject;